module.exports = __webpack_public_path__ + "static/media/support.354166ae.svg";